import React, { Component } from 'react';
import './../css/master.css';
import './../css/construction.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var httpURL = '';
var queryString = require('querystring');
var lstConstruction =[];
var COL_CONSTRUCTIONID 	= 'td:eq(0)';
var COL_CONSTRUCTION 	= 'td:eq(1)';

class Construction extends Component {
  constructor(props){
	super(props);
	this.state={
		construction:[],
		flg:true,
		loader:'none',
		opacity:1,
	}
  }
  
  componentDidMount =()=> {
	this.setState({loader:'block', opacity:0.5});  
	  axiosInstance.get(httpURL+'/a/mst/cons/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					construction:response.data.lstConstruction,
				})
				lstConstruction = this.state.construction;
				this.setConstructionTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  }); 
  }
  
  setConstructionTable =()=> {
		$('#constructionTableBody tr').remove();
		var table 				= document.getElementById('constructionTable');
		var tbody 				= document.getElementById('constructionTableBody');
		var filterConstruction 	= $('#construction').val().toLowerCase();
		
		for(var i=0; i<lstConstruction.length; i++){
		var id 			= lstConstruction[i].constructionId;
		var construction= lstConstruction[i].construction;
		
		var row = document.createElement('tr');
			row.id = id;
		row.onclick =(e)=>{
			$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			this.setConstructionForm($(e.target).closest('tr').attr('id'));
			this.setState({flg:false})
		}
		
		if(construction.toLowerCase().indexOf(filterConstruction) === -1)
			continue;
		
		this.addTD(row, id, 'no-display');
		this.addTD(row, construction, '');
		
		tbody.append(row);
		}
	table.append(tbody);
	}
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	setConstructionForm =(id)=> {
		var constructionData = this.getConstructionData(id);
		if(constructionData !== -1){
			$('#inp_construction').val(constructionData.construction);
		}
	}
	
	getConstructionData(id){
		for(var i = 0; i < lstConstruction.length; i++){
			if(id == lstConstruction[i].constructionId){
				return lstConstruction[i];
			}
		}
		return -1;
	}
	
	addConstructionReady =()=>{
		$('#constructionAddForm').trigger('reset');
		this.setState({flg:true})
	}
	
	maintainConstruction =()=>{
		if(this.state.flg){
			this.addConstruction();
		}else{
			this.editConstruction();
		}
	}
	
	addConstruction=()=>{
	var constructionArr = {};
	var pattern = /^(\d{2,3})[x](\d{2,3})$/;
	var construction	= $('#inp_construction').val();
	if(construction == ''){
		toast.warning('Please fill construction');
		document.getElementById('inp_construction').focus();
		return false;
	}
	
	if(construction.length < 5 || construction.length > 7){
		toast.warning('Construction length should be 5 to 7');
		document.getElementById('inp_construction').focus();
		return false;
	}
	
	if(!(pattern.test(construction))){
		toast.warning('Construction pattern is not valid');
		document.getElementById('inp_construction').focus();
		return false;
	}

	constructionArr={'constructionId': 0, 'construction':construction}
	this.setState({loader:'block', opacity:0.5});
	
	axiosInstance.post(httpURL+'/a/mst/cons/save', 
		queryString.stringify({'construction':JSON.stringify(constructionArr)}), {withCredentials:true}
	).then((response)=>{	
		if(response.data.SvcStatus === "Success"){
			toast.success(response.data.SvcMsg);
			constructionArr.constructionId = response.data.constructionId;
			lstConstruction.push(constructionArr);
			this.setConstructionTable();
			this.setConstructionForm(response.data.constructionId);
			this.highlightRow('constructionTableBody', response.data.constructionId);
			this.setState({flg : false})
		}
		else{
			toast.error(response.data.SvcMsg);
		}
		this.setState({loader:'none', opacity:1});
 	}).catch((e)=>{
         toast.error("Service failed "+e);
  	});
  }

	editConstruction=()=>{
		var constructionArr = {};
		var constructionId 	= $('#constructionTableBody tr.selected').find(COL_CONSTRUCTIONID).text();
		var construction	= $('#inp_construction').val();
		var pattern = /^(\d{2,3})[x](\d{2,3})$/;
		if(constructionId == ''){
			toast.warning('Please select row');
			return false;
		}
		
		if(construction == ''){
			toast.warning('Please fill construction');
			document.getElementById('inp_construction').focus();
			return false;
		}
		
		if(construction.length < 5 || construction.length > 7){
			toast.warning('Construction length should be 5 to 7');
			document.getElementById('inp_construction').focus();
			return false;
		}
		if(!(pattern.test(construction))){
			toast.warning('Construction pattern is not valid');
			document.getElementById('inp_construction').focus();
			return false;
		}
	
		constructionArr = {'constructionId': constructionId, 'construction':construction}
		this.setState({loader:'block', opacity:0.5});
		
		axiosInstance.post(httpURL+'/a/mst/cons/save', 
			queryString.stringify({'construction':JSON.stringify(constructionArr)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				var constructionIdx = this.getIdxConstruction(constructionId);
				lstConstruction.splice(constructionIdx,1,constructionArr);
				this.setConstructionForm(constructionId);
				this.setConstructionTable();
				this.highlightRow('constructionTableBody', constructionId);
			}
			else{
		        toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	getIdxConstruction(constructionId){
		for(var i=0; i<lstConstruction.length; i++){
			if(lstConstruction[i].constructionId == constructionId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var constructionId = $(this).find(COL_CONSTRUCTIONID).text();
			if(constructionId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	
  render() {
	httpURL = window.httpURL;
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-7 col-centered">
						<div className="col-sm-5 col-xs-11 padding-remove">
							<table className="tableLayout">
								<thead>
									<tr>
										<th style={{width:50, display:'none'}}>Construction Id</th>
										<th style={{width:100}}>
											<input onChange={this.setConstructionTable} type="text" className="form-control inp-search" id="construction" placeholder="Construction" />
										</th>
									</tr>
								</thead>
							</table>
							<div className="constructionTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="constructionTable" className="tableLayout">
									<colgroup>
										<col width="100" />
									</colgroup>
									<tbody id="constructionTableBody">
									</tbody>
								</table>
							</div>
						</div>
						<div className="col-sm-1 col-xs-1">
							<span id="addConstruction" title="Add Construction" onClick={this.addConstructionReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-6 col-xs-12">
							<form id="constructionAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Construction:</label>
									<div data-pattern="" className="col-sm-7">
										<input type="text" className="form-control" placeholder="Construction" id="inp_construction"/>
									</div>
								</div>
								<div className="form-group" style={{marginTop:50}}>
									<div className="col-sm-12 text-center">
										<button type="button" onClick={this.maintainConstruction} className="btn btn-warning">Save</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default Construction;
